import { Address } from '@bybeam/platform-types';
import FieldDetail from '@platform-ui-common/components/FieldDetail/index.js';

interface AddressReviewProps {
  address: Omit<Address, 'id' | 'createdAt'>;
}

function AddressReview({ address }: AddressReviewProps): JSX.Element {
  const { addressLine1, addressLine2, city, state, zip } = address;

  return (
    <>
      <FieldDetail label="Street Address">{addressLine1}</FieldDetail>
      {addressLine2 && <FieldDetail label="Apartment/Suite #">{addressLine2}</FieldDetail>}
      <FieldDetail label="City">{city}</FieldDetail>
      <FieldDetail label="State">{state}</FieldDetail>
      <FieldDetail label="Zip Code">{zip}</FieldDetail>
    </>
  );
}

export default AddressReview;
